import React, { FC, PropsWithChildren } from 'react';
import LoggedInHeader from '../Header/LoggedInHeader';
import LoggedOutHeader from '../Header/LoggedOutHeader';
import Navbar from '../Navbar/Navbar';
import { NavbarProvider } from '../../../hooks/useNavbar';
import { CategoryPreview, ArticlePreview, User } from '../../../../shared/types';

import './index.scss';

interface LayoutProps {
  categories: CategoryPreview[];
  topArticles: ArticlePreview[];
  user: User;
}

const Layout: FC<PropsWithChildren<LayoutProps>> = (props) => {
  const { categories, topArticles, children, user } = props;

  return (
    <NavbarProvider>
      <div className="fiverr-guides content-hub">
        {user ? <LoggedInHeader user={user} /> : <LoggedOutHeader />}
        <div className="max-width-container">
          <Navbar categories={categories} topArticles={topArticles} />
          <div className="content-body">{children}</div>
        </div>
      </div>
    </NavbarProvider>
  );
};

export default Layout;
